'use client';
import { ErrorBoundary } from '@jci/components/ErrorBoundary';
import { HOME_PAGE, IN_PROD } from '../config';
import type { ErrorBoundaryProps } from '../utils/appDirTypes';

export default function Error({ error, reset }: ErrorBoundaryProps) {
  return (
    <ErrorBoundary
      error={error}
      homeUrl={HOME_PAGE}
      reset={reset}
      onError={(error) =>
        !IN_PROD && console.error(error, 'Digest: ', error.digest)
      }
    />
  );
}
